const APP_VERSION_KEY = 'app_version';
const VERSION_CHECK_INTERVAL = 60000; // 1 minuto
const LAST_CHECK_KEY = 'app_version_last_check';

export const initializeVersion = async () => {
  if (process.env.NODE_ENV === 'development') {
    return;
  }

  try {
    const response = await fetch('/version.json?t=' + Date.now(), { cache: 'no-cache' });
    if (response.ok) {
      const data = await response.json();
      const storedVersion = localStorage.getItem(APP_VERSION_KEY);
      
      if (!storedVersion && data.version) {
        localStorage.setItem(APP_VERSION_KEY, data.version);
      }
    }
  } catch (error) {
    console.debug('Version initialization skipped');
  }
};

export const checkAndClearStorage = () => {
  // Función legacy mantenida por compatibilidad
  // Ya no limpia el storage automáticamente
  return false;
};

export const startVersionMonitoring = (onVersionChange) => {
  if (process.env.NODE_ENV === 'development') {
    return () => {};
  }

  const checkVersion = async () => {
    try {
      const now = Date.now();
      const lastCheck = localStorage.getItem(LAST_CHECK_KEY);
      
      // Evitar verificaciones duplicadas en múltiples ventanas (dentro de 10 segundos)
      if (lastCheck && (now - parseInt(lastCheck)) < 10000) {
        return;
      }
      
      localStorage.setItem(LAST_CHECK_KEY, now.toString());
      
      const response = await fetch('/version.json?t=' + now, {
        cache: 'no-cache',
        headers: { 'Cache-Control': 'no-cache' }
      });
      
      if (!response.ok) return;
      
      const data = await response.json();
      const storedVersion = localStorage.getItem(APP_VERSION_KEY);
      
      // Solo notificar si hay una versión almacenada Y es diferente
      if (storedVersion && data.version && data.version !== storedVersion) {
        onVersionChange(data.forceLogout || false);
      }
    } catch (error) {
      console.debug('Version check skipped:', error.message);
    }
  };

  const intervalId = setInterval(checkVersion, VERSION_CHECK_INTERVAL);
  
  return () => clearInterval(intervalId);
};
